import axios from 'axios'

/** The day's status the caller read is sent back so the server can refuse a stale override. */
export function dayActionBody(input: {
  action: 'submit' | 'decision' | 'status'
  verdict?: 'Approved' | 'Rejected'
  comment?: string
  expectedStatus?: string
}) {
  if (input.action === 'submit') return undefined
  return {
    verdict: input.verdict,
    comment: input.comment ?? '',
    ...(input.action === 'status' && input.expectedStatus
      ? { expected_status: input.expectedStatus }
      : {}),
  }
}

/** Keyed on the CODE: other 409s on the same route are different refusals. */
export function isStatusChanged(error: unknown): boolean {
  if (!axios.isAxiosError(error) || error.response?.status !== 409) return false
  const detail = error.response?.data?.detail
  return Boolean(detail) && typeof detail === 'object' && detail.code === 'status_changed'
}
